import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import PageController from 'routes';
import ErrorBoundary from 'components/error/boundary';
import { getErrors, getUser } from 'selectors';
import { PAGE_ERROR } from 'constants/errorConstants';
import {
  ResponsiveNavigationBar,
} from 'components/layout/navBar';
import StyledContentContainer, {
  StyledContent,
} from 'components/layout/contentArea/styledContentContainer';
import { publishLocation } from 'actions';
import { featureEnabled } from 'utilities/featureFlag';
import { DMD_REACT_PORTAL } from 'constants/featureFlags';
import ErrorPage from './errorDisplay';
import { AlertBanners } from './components';

const usePageView = (publishPathChange) => {
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
    publishPathChange(history, location);
  }, [location]);
};

const Content = ({
  showContent, errors, publishPathChange, user
}) => {
  usePageView(publishPathChange);
  const hasPageError = Array.isArray(errors[PAGE_ERROR]);

  return (
    <StyledContentContainer>
      <ErrorBoundary>
        <ResponsiveNavigationBar className="nav-bar" />
      </ErrorBoundary>
      <StyledContent>
        {featureEnabled(DMD_REACT_PORTAL) && <AlertBanners user={user} />}
        <ErrorBoundary>
          {showContent && !hasPageError && <PageController />}
          {hasPageError && <ErrorPage errors={errors[PAGE_ERROR]} />}
        </ErrorBoundary>
      </StyledContent>
    </StyledContentContainer>
  );
};

Content.propTypes = {
  errors: PropTypes.object,
  showContent: PropTypes.bool,
  publishPathChange: PropTypes.func.isRequired,
  user: PropTypes.shape({
    id: PropTypes.string,
    customer: PropTypes.object,
  }).isRequired,
};

Content.defaultProps = {
  errors: [],
  showContent: true,
};

function mapStateToProps(state) {
  return {
    errors: getErrors(state),
    user: getUser(state),
  };
}

const mapDispatchToProps = (dispatch) => ({
  publishPathChange: (history, location) => dispatch(
    publishLocation({
      history,
      location,
    })
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(Content);
